import { Injectable, Inject } from '@angular/core';
import { Response, Http } from '@angular/http';
import { HttpClient } from '@angular/common/http';

import * as _ from 'lodash';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { MASTERDATA_ENVIRONMENT } from '../../../environment.config';

import { Customer } from '../model/customer.model';
import { Structure } from '../model/structure.model';
import { StructureStats } from '../model/structure-stats.model';

import { IMasterDataService } from '../../../+common/contracts/master-data.service.contract';
import { Observable } from 'rxjs/Observable';
import { IPerson } from '../../../+common/contracts/person.model.contract';
import { Guest } from '../model/guest.model';
import { Area } from '../model/area.model';
import { IInstanceService } from 'app/+common/contracts/instance-service.contract';
import { Order } from 'app/+core/common/model/order.model';
import { OrderDetailGarment } from 'app/+core/common/model/orderDetailGarment.model';

@Injectable()
export class MasterDataService implements IMasterDataService {
    // private backendUrl = MASTERDATA_ENVIRONMENT;
    private _backendUrl;
    private _instanceType;
    private selectedCustomer: Customer;
    private selectedStructure: Structure;
    private selectedArea: Area;
    private selectedPerson: IPerson;
    private firstShelfboxFree: number;
    private selectedOrder: Order = new Order();

    get backendUrl(): string {
        if (this._backendUrl && this._backendUrl != "")
            return this._backendUrl;
        else
            return localStorage.getItem("backendURL");
    }
    set backendUrl(url: string) {
        this._backendUrl = url;
    }

    get instanceType(): string {
        if (this._instanceType && this._instanceType != "")
            return this._instanceType;
        else
            return localStorage.getItem("exaco-instance-type");
    }
    set instanceType(type: string) {
        this._instanceType = type;
    }

    constructor(private http: HttpClient, private httpOld: Http, @Inject('IInstanceService') private instanceService: IInstanceService) {
        this.httpOld.get('assets/configuration/environment.json')
            .map(res => res.json())
            .toPromise()
            .then((config: any) => {
                this.backendUrl = config.url;
                this.instanceType = config.env;
                localStorage.setItem("backendURL", config.url);
                localStorage.setItem("exaco-instance-type", config.env);

                console.log(config.url);
                console.log(config.env);
            });
    }

    private extractData = (res: any) => res

    private handleError(error: Response | any) {
        // In a real world app, you might use a remote logging infrastructure
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable.throw(errMsg);
    }

    getCustomerList$(): Observable<Customer[]> {
        const custs = localStorage.getItem("exaco-customers")
        return custs ? Observable.from([JSON.parse(custs)]) :
            this.http
                .get(this.backendUrl + 'customers')
                .map(cust => {
                    localStorage.setItem("exaco-customers", JSON.stringify(cust))
                    return cust
                })
                .catch(this.handleError);
    }

    private findLocalCustomer(custs: Customer[], customerId: number): Observable<Customer> {
        return Observable.from([custs.find(f => f.id === customerId)])
    }

    getCustomer$(customerId: number): Observable<Customer> {
        const custs = localStorage.getItem("exaco-customers")
        return custs ? this.findLocalCustomer(JSON.parse(custs), customerId) :
            this.http.get(this.backendUrl + 'customers/' + customerId)
                .map(this.extractData)
                .catch(this.handleError);

    }

    // INSTANCE VERSION
    getPersonList$(customerId: string): Observable<IPerson[]> {
        return this.http
            .get(this.backendUrl + 'guests/') // Ezio: TODO: add customerId when backend is ready to handle it
            .map(this.extractData)
            .catch(this.handleError);
    }

    // MASTER VERSION
    // getPersonListMaster$(customerId: string): Observable<IPerson[]>
    // {
    //     return this.http
    //         .get(this.backendUrl + 'guests-master/customer/' + customerId) // Ezio: TODO: add customerId when backend is ready to handle it
    //         .map(this.extractData)
    //         .catch(this.handleError);
    // }

    // getPersonMaster$(instanceId: number, personId: number): Observable<IPerson>
    // {
    //     return this.http
    //         .get(this.backendUrl + 'guests-master/' + personId + '/instance/' + instanceId) // Ezio: TODO: add customerId when backend is ready to handle it
    //         .map(this.extractData)
    //         .catch(this.handleError);
    // }

    getActivePersonList$(customerId: string): Observable<IPerson[]> {
        return this.http
            .get(this.backendUrl + 'guests/enabled') // Ezio: TODO: add customerId when backend is ready to handle it
            .map(this.extractData)
            .catch(this.handleError);
    }

    // getPersonListWithGarmentsInProcess$(customerId: string): Observable<IPerson[]>
    // {
    //     return this.http
    //         .get(this.backendUrl + 'guests/inprocess') // Ezio: TODO: add customerId when backend is ready to handle it
    //         .map(this.extractData)
    //         .catch(this.handleError);
    // }
    getPersonListWithGarmentsInProcess$(customerId: string): Observable<IPerson[]> {
        return this.http
            //.get(this.instanceService.isInstanceMaster() ? this.backendUrl + 'guests-master/inprocess' : this.backendUrl + 'guests/inprocess') // Ezio: TODO: add customerId when backend is ready to handle it
            .get(this.backendUrl + 'guests/inprocess')
            .map(this.extractData)
            .catch(this.handleError);
    }


    getPersonListByStructure$(customerId: string, structureId: number): Observable<IPerson[]> {
        return this.http
            .get(this.backendUrl + 'guests/structures/' + structureId) // Ezio: TODO: add customerId when backend is ready to handle it
            .map(this.extractData)
            .catch(this.handleError);
    }

    getPerson$(customerId: string, personId: number): Observable<IPerson> {
        //return this.personList.find(x => x.id === personId);
        return this.http
            .get(this.backendUrl + 'guests/' + personId) // Ezio: TODO: add customerId when backend is ready to handle it
            .map(this.extractData)
            .catch(this.handleError);
    }

    getStructureList$(customerId?:number): Observable<Structure[]> {
        const structs = localStorage.getItem('exaco-structures')
        return structs ? Observable.from([JSON.parse(structs)]) : this.http
            .get(this.backendUrl + 'structures')
            .map(struct => {
                localStorage.setItem('exaco-structures', JSON.stringify(struct))
                return struct
            })
            .catch(this.handleError);
    }

    private findLocalStruct(structs: Structure[], structureId: number): Observable<Structure> {
        return Observable.from([structs.find(f => f.id === structureId)])
    }

    private findLocalStructs(structs: Structure[], customerId: number): Observable<Structure> {
        var f = Observable.from(structs.filter(f => f.customerId === customerId) as Structure[])
        return f;
    }

    getStructure$(structureId: number): Observable<Structure> {
        const structs = localStorage.getItem('exaco-structures')
        return structs ? this.findLocalStruct(JSON.parse(structs), structureId) :
            this.http.get(this.backendUrl + 'structures/' + structureId)
                .map(this.extractData)
                .catch(this.handleError);
    }

    getStructures$(customerId: number): Observable<Structure[]> {
        const structs = localStorage.getItem('exaco-structures')
        return structs ? this.findLocalStructs(JSON.parse(structs), customerId) :
            this.http.get(this.backendUrl + 'customers/' + customerId)
                .map((s:Customer) => s.structureList)
                .catch(this.handleError);
    }

    getStructureStats$(customerId: number, structure: Structure): Observable<StructureStats> {
        return this.http
            .get(this.backendUrl + 'structures/' + customerId + '/' + structure.id + '/stats')
            .map(this.extractData)
            .catch(this.handleError);
    }
    getAreaList$(): Observable<Area[]> {
        return this.http
            .get(this.backendUrl + 'structures/areas')
            .map(this.extractData)
            .catch(this.handleError);
    }

    getSelectedPerson(): IPerson {
        return this.selectedPerson;
    }
    setSelectedPerson(person: IPerson) {
        this.selectedPerson = person;
    }
    getSelectedCustomer(): Customer {
        return this.selectedCustomer;
    }
    setSelectedCustomer(customer: Customer) {
        this.selectedCustomer = customer;
    }
    getSelectedStructure(): Structure {
        return this.selectedStructure;
    }
    setSelectedStructure(structure: Structure) {
        this.selectedStructure = structure;
    }
    getSelectedArea(): Area {
        return this.selectedArea;
    }
    setSelectedArea(area: Area) {
        this.selectedArea = area;
    }

    getFirstShelfboxFree() {
        return this.firstShelfboxFree;
    }
    setFirstShelfboxFree(shelfbox: number) {
        this.firstShelfboxFree = shelfbox;
    }

    updatePerson(person: Guest): Observable<Guest> {
        return this.http
            .post(this.backendUrl + 'guests', person)
            .map(this.extractData)
            .catch(this.handleError)
    }
    createPerson(person: Guest): Observable<Guest> {
        return this.updatePerson(person);
    }

    updateStructure(structure: Structure): Observable<Structure> {
        return this.http
            .post(this.backendUrl + 'structures/111', structure)
            .map(this.extractData)
            .catch(this.handleError)
    }
    createStructure(structure: Structure): Observable<Structure> {
        return this.updateStructure(structure);
    }

    updateCustomer(customer: Customer): Observable<Customer> {
        return this.http
            .post(this.backendUrl + 'customers', customer)
            .map(this.extractData)
            .catch(this.handleError)
    }
    createCustomer(customer: Customer): Observable<Customer> {
        return this.updateCustomer(customer);
    }

    getOrders(): Observable<Order[]> {
        return this.http
            .get(this.backendUrl + 'orders/')
            .map(this.extractData)
            .catch(this.handleError);
    }

    getOrdersByCustomerId(customerId: number): Observable<Order[]> {
        return this.http
            .get(this.backendUrl + 'orders/' + customerId)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getOrdersByState(state: number): Observable<Order[]> {
        return this.http
            .get(this.backendUrl + 'orders/state/' + state)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getOrdersByRFIDList(rfidList: Array<string>): Observable<Order[]> {
        return this.http
            .post(this.backendUrl + 'orders/delivered/', rfidList)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getOrderById(orderId: number): Observable<Order> {
        return this.http
            .get(this.backendUrl + 'order/' + orderId)
            .map((order: Order) => {
                order.orderDetails.forEach(o => {
                    o.remaining =  o.garments ? o.quantity - o.garments.length : o.quantity;
                })
                return order
            })
            .catch(this.handleError);
    }

    saveOrder(order: Order): Observable<Order> {
        let orderToSend = _.cloneDeepWith(order);
        delete orderToSend.productOrders;

        return this.http
            .post(this.backendUrl + 'orders/product/', orderToSend)
            .map(this.extractData)
            .catch(this.handleError);
    }

    saveOrderAllocation(order: Order): Observable<Order> {
        let orderToSend = _.cloneDeepWith(order);
        delete orderToSend.productOrders;

        return this.http
            .post(this.backendUrl + 'orders/product/allocation', orderToSend)
            .map(this.extractData)
            .catch(this.handleError);
    }

    saveOrderGarments(order: Order): Observable<Order> {
        let orderToSend = _.cloneDeepWith(order);
        delete orderToSend.productOrders;

        return this.http
            .post(this.backendUrl + 'orders/garments/', orderToSend)
            .map(this.extractData)
            .catch(this.handleError);
    }

    saveOrderState(order: Order) {
        return this.http
            .post(this.backendUrl + 'order/state/', order)
             .map(this.extractData)//.toPromise<Order>()
             .catch(this.handleError);
    }

    deleteOrder(orderId: number): Observable<Order> {
        return this.http
            .delete(this.backendUrl + 'order/' + orderId)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getSelectedOrder(): Order {
        return this.selectedOrder;
    }

    setSelectedOrder(order: Order) {
        this.selectedOrder = order;
    }

    setOrderDetailGarmentState(orderDetailGarment: OrderDetailGarment[]){
        return this.http
            .post(this.backendUrl + 'orderdetailgarment/state', orderDetailGarment).toPromise()
        // .map(this.extractData)
        // .catch(this.handleError);   
    }

    updateProductOnPremise(order: Order){
        return this.http.post(this.backendUrl + 'updateProductOnPremise', order).toPromise()
    }
}



// WEBPACK FOOTER //
// ./src/app/+master-data/common/services/master-data.service.ts